"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VictoryClipContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactNativeSvg = require("react-native-svg");
var _circle = require("./victory-primitives/circle");
var _rect = require("./victory-primitives/rect");
var _clipPath = require("./victory-primitives/clip-path");
var _es = require("victory-core/es");
var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class VictoryClipContainer extends _es.VictoryClipContainer {
  static defaultProps = {
    ..._es.VictoryClipContainer.defaultProps,
    groupComponent: /*#__PURE__*/_react.default.createElement(_reactNativeSvg.G, null),
    rectComponent: /*#__PURE__*/_react.default.createElement(_rect.Rect, null),
    clipPathComponent: /*#__PURE__*/_react.default.createElement(_clipPath.ClipPath, null),
    circleComponent: /*#__PURE__*/_react.default.createElement(_circle.Circle, null)
  };

  // There seems to be a caching issue with clip paths.
  // This is required to make clip paths update when animating
  componentDidUpdate() {
    this.clipId = (0, _uniqueId.default)("victory-clip-");
  }
}
exports.VictoryClipContainer = VictoryClipContainer;